import { expandEnergyPlaceholders } from "./energy.js";

export { expandEnergyPlaceholders } from "./energy.js";

/** Slim card catalog shape stored at `catalog/cards.json` (built from the client's card database). */
export type CatalogCard = {
  name: string;
  set: string;
  number: string;
  type?: string;
  hp?: number;
  reg?: string;
};

export type CardCatalog = Record<string, CatalogCard>;

const PRINT_SUFFIX = /^(.*?)_(?:ph|sph|sf)$/;

/** Look a client id up, falling back to the base print when only a variant is known. */
export function lookupCard(catalog: CardCatalog, cardId: string): CatalogCard | undefined {
  const direct = catalog[cardId];
  if (direct !== undefined) return direct;
  const base = PRINT_SUFFIX.exec(cardId)?.[1];
  return base === undefined ? undefined : catalog[base];
}

export function cardDisplayName(catalog: CardCatalog | undefined, cardId: string): string {
  if (catalog === undefined) return cardId;
  const name = lookupCard(catalog, cardId)?.name;
  return name === undefined ? cardId : expandEnergyPlaceholders(name);
}
